import React, { useState } from "react";
import {
  SwipeableDrawer,
  Box,
  Typography,
  IconButton,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  CardMedia,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import baggageImg from "../../Assets/Services/Flight/baggage.webp";

const BaggageDrawer = ({
  open,
  onClose,
  onOpen,
  baggageData,
  selectedBaggage,
  setSelectedBaggage,
  passengerCount = 1,
  travelerDetails = [],
  onDone,
}) => {
  const [finalizedTravelerData, setFinalizedTravelerData] = useState([]);

  const handleToggleBaggage = (travelerIndex, baggage) => {
    setSelectedBaggage((prev) => {
      const isSelected =
        prev?.[travelerIndex]?.AirlineCode === baggage.AirlineCode &&
        prev?.[travelerIndex]?.FlightNumber === baggage.FlightNumber &&
        prev?.[travelerIndex]?.Code === baggage.Code;

      return {
        ...prev,
        [travelerIndex]: isSelected ? null : baggage,
      };
    });
  };
  const handleDone = () => {
    const merged = travelerDetails.map((traveler, index) => ({
      ...traveler,
      selectedBaggage: selectedBaggage?.[index] || null,
    }));

    setFinalizedTravelerData(merged);

    console.log("Final Traveler + Baggage Data:", merged);
    if (onDone) {
      onDone(merged); // ⬅️ Pass finalized data to parent
    }
    onClose(); // optionally close drawer
  };
  const renderBaggageOptions = (travelerIndex) => {
    const baggageList = baggageData?.[0] || [];

    if (baggageList.length === 0) {
      return (
        <Typography variant="body1" color="textSecondary">
          No baggage options available.
        </Typography>
      );
    }



    return (
      <Grid container spacing={2}>
        {baggageList
          .filter((baggage) => baggage.Code !== "NoBaggage")
          .map((baggage, index) => {
            const isSelected =
              selectedBaggage?.[travelerIndex]?.AirlineCode === baggage.AirlineCode &&
              selectedBaggage?.[travelerIndex]?.FlightNumber === baggage.FlightNumber &&
              selectedBaggage?.[travelerIndex]?.Code === baggage.Code;

            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card>
                  <CardMedia
                    component="img"
                    height="120"
                    image={baggageImg}
                    alt="Baggage"
                  />
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold">
                      Weight: {baggage.Weight} kg
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Price:{" "}
                      <strong>
                        {baggage.Currency === "INR" ? "₹" : baggage.Currency} {baggage.Price}
                      </strong>
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="outlined"
                      color={isSelected ? "secondary" : "primary"}
                      size="small"
                      onClick={() => handleToggleBaggage(travelerIndex, baggage)}
                    >
                      {isSelected ? "Deselect" : "Select"}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
      </Grid>
    );
  };

  return (
    <SwipeableDrawer anchor="right" open={open} onClose={onClose} onOpen={onOpen}>
      <Box sx={{ width: 950, p: 3, mb: "150px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold">
            Select Baggage
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box mt={3}>
          {Array.isArray(travelerDetails) && travelerDetails.length > 0 ? (
            travelerDetails.map((traveler, index) => (
              <Accordion key={index} defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {traveler.name
                      ? `Traveler ${index + 1}: ${traveler.name}`
                      : `Traveler ${index + 1}`}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>{renderBaggageOptions(index)}</AccordionDetails>
              </Accordion>
            ))
          ) : (
            <Typography variant="body1" color="textSecondary">
              Loading traveler details...
            </Typography>
          )}
        </Box>

      </Box>

      <Box
        sx={{
          background: "#e3e3e3",
          width: "100%",
          height: "10%",
          position: "fixed",
          bottom: 0,
          padding: "16px",
          display: "flex",
          justifyContent: "flex-start", // Center both elements together
          gap: "16px",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" color="primary">
          Total Price:{" "}
          <strong>
            {Object.values(selectedBaggage || {}).reduce((total, baggage) => {
              if (baggage?.Price) return total + baggage.Price;
              return total;
            }, 0)}
          </strong>
        </Typography>

        <Button variant="contained" color="primary" onClick={handleDone}>
          Done
        </Button>
      </Box>
    </SwipeableDrawer>
  );
};

export default BaggageDrawer;
